(() => {
  const offer = document.querySelector('[data-oma-header] [data-offer-ends]');
  function expireOffer() {
    if (!offer) return;
    const remaining = Date.parse(offer.dataset.offerEnds) - Date.now();
    if (remaining <= 0) { offer.remove(); document.querySelector('[data-oma-header]').classList.add('om-oma-offer-expired'); }
    else setTimeout(expireOffer, Math.min(remaining, 2147483647));
  }
  expireOffer();
  const hero = document.querySelector('[data-oma-header] .om-oma-hero'), track = hero.querySelector('.om-oma-slides-track');
  const slides = [...track.querySelectorAll('[data-slide]')];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)'), mobile = matchMedia('(max-width:767px)');
  let current = 0, settleTimer, frame, ticker, touching = false;
  function copySlide(slide, suffix) {
    const copy = slide.cloneNode(true);
    copy.dataset.clone = suffix; copy.removeAttribute('data-slide'); copy.setAttribute('aria-hidden','true'); copy.inert = true;
    const ids = new Map();
    copy.querySelectorAll('[id]').forEach(el => { const old=el.id; el.id=suffix+'-'+old; ids.set(old,el.id); });
    copy.querySelectorAll('*').forEach(el => [...el.attributes].forEach(attr => {
      let value=attr.value;ids.forEach((next,old) => { value=value.replaceAll('url(#'+old+')','url(#'+next+')');if(value==='#'+old)value='#'+next; });
      if(value!==attr.value)el.setAttribute(attr.name,value);
    }));
    return copy;
  }
  const head = copySlide(slides[1],'head'), tail = copySlide(slides[0],'tail');
  track.prepend(head); track.append(tail);
  const row=[head,...slides,tail];
  function original(el) { return el===head?slides[1]:el===tail?slides[0]:el; }
  function mark(index, announce=false) {
    current=index;
    slides.forEach((slide,i)=>{const hidden=mobile.matches&&i!==current;slide.inert=hidden;slide.toggleAttribute('aria-hidden',hidden);if(hidden)slide.setAttribute('aria-hidden','true');});
    if(announce)document.getElementById('om-oma-slide-status').textContent=current===0?'OMA Mom, image 1 of 2':'Best friends, image 2 of 2';
  }
  function show(index,direction=0) {
    if(!mobile.matches)return;
    const next=(index+2)%2;
    let target=slides[next];
    if(direction>0&&current===1&&next===0)target=tail;
    if(direction<0&&current===0&&next===1)target=head;
    track.scrollTo({left:target.offsetLeft,behavior:reduce.matches?'instant':'smooth'});
    mark(next,true);
  }
  function settle() {
    if(!mobile.matches||touching)return;
    const el=row[Math.round(track.scrollLeft/track.clientWidth)];if(!el)return;
    if(Math.abs(track.scrollLeft-el.offsetLeft)>2)return;
    if(el===head||el===tail)track.scrollTo({left:original(el).offsetLeft,behavior:'instant'});
    mark(slides.indexOf(original(el)));
  }
  track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const el=row[Math.round(track.scrollLeft/track.clientWidth)];if(el)mark(slides.indexOf(original(el)));});clearTimeout(settleTimer);settleTimer=setTimeout(settle,140);},{passive:true});
  track.addEventListener('scrollend',settle);
  track.addEventListener('touchstart',()=>{touching=true;clearTimeout(settleTimer);},{passive:true});
  ['touchend','touchcancel'].forEach(type=>track.addEventListener(type,()=>{touching=false;settleTimer=setTimeout(settle,140);},{passive:true}));
  hero.addEventListener('keydown',e=>{if(!mobile.matches)return;if(e.key==='ArrowRight'){e.preventDefault();show(current+1,1);}if(e.key==='ArrowLeft'){e.preventDefault();show(current-1,-1);}});
  function syncMotion(){if(ticker)ticker.paused(document.hidden||reduce.matches);}
  document.addEventListener('visibilitychange',syncMotion);
  reduce.addEventListener('change',syncMotion);
  function layout(){track.scrollTo({left:mobile.matches?slides[current].offsetLeft:0,behavior:'instant'});mark(current);hero.setAttribute('aria-roledescription',mobile.matches?'carousel':'collection images');}
  let width=track.clientWidth;
  new ResizeObserver(()=>{if(width!==track.clientWidth){width=track.clientWidth;layout();}}).observe(track);
  mobile.addEventListener('change',layout);layout();
})();
